import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import { TooltipsService } from '../../services/tooltips.service';
import './form-container-related-links-student-loans.component.scss';
import * as _ from 'lodash';
import * as $ from 'jquery';
import 'bootstrap-datepicker';
var FormContainerRelatedLinksStudentLoans = /** @class */ (function (_super) {
    tslib_1.__extends(FormContainerRelatedLinksStudentLoans, _super);
    function FormContainerRelatedLinksStudentLoans(element) {
        var _this = _super.call(this, element) || this;
        _this.event.register('openModal', _this, _this.openModal.bind(_this));
        return _this;
    }
    FormContainerRelatedLinksStudentLoans.prototype.init = function () {
        this.form = this.element.querySelector('form');
        this.modals = Array.from(this.element.querySelectorAll('.js-apply-now-modal'));
        this.modalLinks = Array.from(document.querySelectorAll('.js-relatedLinks-modal-open'));
        this.closeButton = this.element.querySelector('.js-apply-now-modal-close');
        this.relatedLinksContainer = this.element.querySelector('.related__links');
        this.relatedLinksModalsContainer = this.element.querySelector('.related__links-modals');
        this.modalButtons = Array.from(this.element.querySelectorAll('.js-rlinks-show-form'));
        this.headerDivs = Array.from(this.element.querySelectorAll('.form-container-related-links-student-loans__header'));
        this.content1Divs = Array.from(this.element.querySelectorAll('.form-container-related-links-student-loans__block--content'));
        this.content2Divs = Array.from(this.element.querySelectorAll('.form-container-related-links-student-loans__block--content2'));
        TooltipsService.initTooltips();
    };
    FormContainerRelatedLinksStudentLoans.prototype.bindEvents = function () {
        var _this = this;
        this.modals.map(function (item) { return item.addEventListener('click', function (event) {
            _this.isClickOutsideModal(event);
        }); });
        this.closeButton.addEventListener('click', function (event) { return _this.closeModal(); });
        this.modalButtons.map(function (pButton) {
            pButton.addEventListener('click', function (pEvent) {
                if (_this.relatedLinksContainer) {
                    _this.relatedLinksContainer.classList.add('form-container-related-links-student-loans__hidden');
                }
                if (_this.relatedLinksModalsContainer) {
                    _this.relatedLinksModalsContainer.classList.remove('form-container-related-links-student-loans__hidden');
                }
                _this.currentModal = pEvent.target.closest('.modal__dialog');
                if (_this.currentModal) {
                    _this.currentModal.classList.add('modal__dialog--small');
                    _this.currentModal.classList.remove('modal__dialog--large');
                }
            });
        });
        window.addEventListener('resize', this.debounce(function () {
            _this.updateScreenInfo();
        }, 250, false));
        document.addEventListener('click', function (e) {
            var composedPath = function (el) {
                var path = [];
                while (el) {
                    path.push(el);
                    if (el.tagName === 'HTML') {
                        path.push(document);
                        path.push(window);
                        return path;
                    }
                    el = el.parentElement;
                }
            };
            var path = e.path || (e.composedPath && e.composedPath()) || composedPath(e.target);
            var hasClass = function (cls) {
                return _.filter(path, function (p) {
                    var exists = false;
                    _.each(p.classList, function (cl) {
                        if (cl === cls) {
                            exists = true;
                        }
                    });
                    if (p.classList && exists) {
                        return p;
                    }
                })[0];
            };
            if (hasClass('js-apply-now-modal-open')) {
                _this.openModals(e);
            }
        }, false);
    };
    FormContainerRelatedLinksStudentLoans.prototype.updateScreenInfo = function () {
        // Width = 768 - standard tablet potrait as defined in the config.scss: $tablet-portrait
        if (window.innerWidth >= 768) {
            if (this.headerDivs && this.content1Divs && this.content2Divs) {
                // Header Divs
                if (this.headerDivs.length > 1) {
                    var height1 = this.headerDivs[0].clientHeight;
                    var height2 = this.headerDivs[1].clientHeight;
                    if (height1 !== 0 && height2 !== 0) {
                        if (height1 > height2) {
                            this.headerDivs[1].style.height = height1 + 'px';
                        }
                        else {
                            this.headerDivs[0].style.height = height2 + 'px';
                        }
                    }
                }
                // Content 1 Divs
                if (this.content1Divs.length > 1) {
                    var height1 = this.content1Divs[0].clientHeight;
                    var height2 = this.content1Divs[1].clientHeight;
                    if (height1 !== 0 && height2 !== 0) {
                        if (height1 > height2) {
                            this.content1Divs[1].style.height = height1 + 'px';
                        }
                        else {
                            this.content1Divs[0].style.height = height2 + 'px';
                        }
                    }
                }
                // Content 2 Divs
                if (this.content2Divs.length > 1) {
                    var height1 = this.content2Divs[0].clientHeight;
                    var height2 = this.content2Divs[1].clientHeight;
                    if (height1 !== 0 && height2 !== 0) {
                        if (height1 > height2) {
                            this.content2Divs[1].style.height = height1 + 'px';
                        }
                        else {
                            this.content2Divs[0].style.height = height2 + 'px';
                        }
                    }
                }
            }
        }
    };
    FormContainerRelatedLinksStudentLoans.prototype.onResize = function () {
        setTimeout(function () {
            // this.equalHeights();
        }, 100);
    };
    FormContainerRelatedLinksStudentLoans.prototype.debounce = function (func, wait, immediate) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) {
                    func.apply(context, args);
                }
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) {
                func.apply(context, args);
            }
        };
    };
    FormContainerRelatedLinksStudentLoans.prototype.isClickOutsideModal = function (event) {
        if (event.target === this.activeModal) {
            this.closeModal();
        }
    };
    FormContainerRelatedLinksStudentLoans.prototype.openModals = function (event) {
        var element = event.target;
        var modalId = element.getAttribute('data-modal');
        if (!modalId) {
            var parentElement = $(element).closest('.js-apply-now-modal-open');
            modalId = parentElement.attr('data-modal');
        }
        this.activeModal = this.getModalById(modalId);
        this.openModal();
    };
    FormContainerRelatedLinksStudentLoans.prototype.closeModal = function () {
        var _this = this;
        this.analyticsService.dtmFormAbandon();
        this.activeModal.classList.add('modal--close');
        setTimeout(function () {
            _this.activeModal.classList.add('modal--closed');
        }, 250);
    };
    FormContainerRelatedLinksStudentLoans.prototype.openModal = function () {
        if (this.activeModal) {
            this.resetForm();
            this.activeModal.classList.remove('modal--close');
            this.activeModal.classList.remove('modal--closed');
        }
    };
    FormContainerRelatedLinksStudentLoans.prototype.getModalById = function (id) {
        return document.getElementById(id);
    };
    FormContainerRelatedLinksStudentLoans.prototype.resetForm = function () {
        if (this.form) {
            this.form.reset();
            var formContainerLoader = this.element.querySelector('.form__loader--container');
            var formContainerFields = this.element.querySelector('.form__fields--container');
            var formContainerThankyou = this.element.querySelector('.form__thankyou--container');
            if (formContainerLoader) {
                formContainerLoader.classList.remove('active');
            }
            if (formContainerThankyou) {
                formContainerThankyou.classList.remove('active');
            }
            if (formContainerFields) {
                formContainerFields.classList.remove('hidden');
            }
            // allow individual form items components to handle form reset
            var event_1 = new Event('custom_form_reset_event');
            this.form.dispatchEvent(event_1);
        }
        if (this.relatedLinksContainer) {
            this.relatedLinksContainer.classList.remove('form-container-related-links-student-loans__hidden');
        }
        if (this.relatedLinksModalsContainer) {
            this.relatedLinksModalsContainer.classList.add('form-container-related-links-student-loans__hidden');
        }
        if (this.currentModal) {
            this.currentModal.classList.remove('modal__dialog--small');
            this.currentModal.classList.add('modal__dialog--large');
        }
    };
    return FormContainerRelatedLinksStudentLoans;
}(Base));
export { FormContainerRelatedLinksStudentLoans };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-container-related-links-student-loans/form-container-related-links-student-loans.component.ts
// module id = 799
// module chunks = 0